module.exports = __webpack_public_path__ + "img/Previous2.980473d7.svg";